import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.app-link {
	color: ${dt('primary.color')};
	cursor: pointer;
	text-decoration: none;
}

button.app-link {
	background: none;
	border: none;
	padding: 0;
	font: inherit;
	text-align: left;
}

.app-link:hover {
	text-decoration: underline;
}
`;
